module.exports = __webpack_public_path__ + "img/jet6_feature_02.d1554e87.jpg";